import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import UI from '../ui';
import BrandedTrackingButtons from './BrandedTrackingButtons.component';
import DesignTabPanel from './DesignTabPanel.component';
import LinksTabPanel from './LinksTabPanel.component';
import StoresTabPanel from './StoresTabPanel.component';
import EmailsTabPanel from './EmailsTabPanel.component';
import Util from './Util';

const { WrappedTabView } = UI;

const Editor = props => {
	const {
		branding: {
			brandingId,
			reference,
			brandingProperties: {
				Theme: themeKey,
				BrandName: storeName,
				LogoTargetUrl: storeUrl,
				LogoType: logoType,
				LogoUrl: logoUrl,
				LogoName: logoName,
				Email: email,
				Phone: phone,
				ReturnPolicy: returnPolicy,
				MenuLinks: menuLinks,
				SocialMedia: socialMedia,
				TempLogoId: tempLogoId,
			},
		},
		notification: {
			notificationSettingProperties: {
				AllowSMSOptIn: allowSmsOptIn,
				Triggers: triggers,
				EmailConfig: {
					ContentBlocks: [
						{ Value: promotional } = { ContentBlockType: 'Alert', Value: '' },
					],
					FromName: fromName,
					ReplyToEmail: replyToEmail,
					BCCEmails: bccEmails,
				},
			},
		},
		isValidationNeeded,
		setBrandedTrackingConfig,
		setNotificationSettingsConfig,
		setReference,
		storesList,
		bccEmailsEnabled,
		setBccEmailsEnabled,
		activeTabIndex,
		setActiveTabIndex,
		onNext,
		onSave,
		onPublish,
	} = props;

	const isNew = !brandingId;
	const isPublished = reference && reference.isActive;

	const tabItems = [
		{
			header: 'Design',
			content: (
				<DesignTabPanel
					allowSmsOptIn={allowSmsOptIn}
					setBrandedTrackingConfig={setBrandedTrackingConfig}
					setNotificationSettingsConfig={setNotificationSettingsConfig}
					themeKey={themeKey}
					storeName={storeName}
					storeUrl={storeUrl}
					logoType={logoType}
					logoUrl={logoUrl}
					logoName={logoName}
					tempLogoId={tempLogoId}
					isValidationNeeded={isValidationNeeded}
				/>
			),
		},
		{
			header: 'Links',
			content: (
				<LinksTabPanel
					setBrandedTrackingConfig={setBrandedTrackingConfig}
					email={email}
					phone={phone}
					returnPolicy={returnPolicy}
					menuLinks={menuLinks}
					socialMedia={socialMedia}
					isValidationNeeded={isValidationNeeded}
				/>
			),
		},
		{
			// The tab title is default to 'Status' if there are no connected stores or empty reference
			header: isEmpty(reference) || Util.isNoStoreConnected(storesList) ? 'Status' : 'Stores',
			content: (
				<StoresTabPanel
					reference={reference}
					storesList={storesList}
					setReference={setReference}
				/>
			),
		},
		Util.canUseBrandedEmails()
			? {
					header: 'Emails',
					content: (
						<EmailsTabPanel
							setNotificationSettingsConfig={setNotificationSettingsConfig}
							triggers={triggers}
							replyToEmail={replyToEmail}
							fromName={fromName}
							promotional={promotional}
							bccEmails={bccEmails}
							bccEmailsEnabled={bccEmailsEnabled}
							setBccEmailsEnabled={setBccEmailsEnabled}
							isValidationNeeded={isValidationNeeded}
						/>
					),
			  }
			: null,
	].filter(tabItem => tabItem);

	return (
		<div className="branded-tracking-editor">
			<WrappedTabView
				activeIndex={activeTabIndex}
				onTabChange={e => setActiveTabIndex(e.index)}
				tabItems={tabItems}
			/>
			<BrandedTrackingButtons
				activeTabIndex={activeTabIndex}
				isNew={isNew}
				isPublished={isPublished}
				onNext={onNext}
				onSave={onSave}
				onPublish={onPublish}
			/>
		</div>
	);
};

Editor.propTypes = {
	setBrandedTrackingConfig: PropTypes.func.isRequired,
	setNotificationSettingsConfig: PropTypes.func.isRequired,
};

export default Editor;
